import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const Tour2Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TourIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M22.8999 8.30832V18.3739C22.8999 19.2702 22.0673 20.0001 21.0398 20.0001H4.75995C3.73249 20.0001 2.8999 19.2702 2.8999 18.3739V8.30832C2.8999 7.40841 3.73603 6.68211 4.75995 6.68211H7.36758V6.68919C7.4101 6.72816 9.95392 9.36413 12.9052 9.36413C15.8565 9.36413 18.4003 6.72816 18.4429 6.68919V6.68211H21.0363C22.0673 6.68211 22.8964 7.40841 22.8964 8.30832"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.4433 6.67848L7.36758 6.68211C7.4101 6.63605 9.95433 4 12.9056 4C15.8569 4 18.4007 6.63596 18.4433 6.67848Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default Tour2Icon;
